import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';

const Wrapper = styled.div`
  height: ${spacing.x16};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const PieChartPlaceholder = styled(Skeleton)`
  height: ${spacing.x10};
  width: ${spacing.x10};
  border-radius: ${spacing.x10};
`;

export const PIE_CHART_SKELETON_DATA_TEST = 'pie-chart-skeleton';

export const PieChartSkeleton = () => (
  <Wrapper data-test={PIE_CHART_SKELETON_DATA_TEST}>
    <PieChartPlaceholder />
  </Wrapper>
);
